export default {
  mounted (el, binding, vnode) {
    const regex = /[^a-zа-яё\s]/gi
    el.oninput = function (e) {
      e.target.value = e.target.value.replace(regex, '')
    }
  }
}
